<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("view") }} {{ $t("ticketpriceconfiguration") }}
      </div>
      <router-link
        v-if="$can('update', 'Ticket Price Configuration')"
        class="btn-blue"
        to="edit-ticket-price-configuration"
        >{{ $t("edit") }}</router-link
      >
    </div>

    <div class="all-details-container">
      <div
        v-for="(item, itemIndex) in viewTicketPriceConfigurationDetails"
        :key="itemIndex"
        class="col-md-12"
      >
        <div v-if="itemIndex == 0" class="row">
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("cinema", 2) }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ item.cine_name }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("movie", 1) }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ item.movie_title }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("screens") }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ item.screen_name }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("fromdate") }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ item.p_start_date_time | dateparse }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("todate") }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ item.p_end_date_time | dateparse }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("status", 1) }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ item.p_is_active ? $t("active") : "" }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("createdby") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <!-- <span>{{ $tc('ho', 1) }} {{ $t('manager') }}</span> -->
                <span>{{ item.created_by ? item.created_by : "" }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("createdat") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span class="mr-3">{{
                  item.created_at ? item.created_at : "" | dateparse
                }}</span>
                <!-- <span class="mr-3">06/04/2019</span>
                <span>12:05 AM</span>-->
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("modifiedby") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <!-- <span>{{ $tc('ho', 1) }} {{ $t('manager') }}</span> -->
                <span>{{
                  item.updated_by ? SchedulePriceObject.updated_by : ""
                }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("modifiedat") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <!-- <span class="mr-3">06/04/2019</span> -->
                <!-- <span>12:05 AM</span> -->
                <span class="mr-3">{{
                  item.updated_at ? item.updated_at : "" | dateparse
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <hr v-if="itemIndex == 0" />
        <div class="row">
          <div class="col-md-3">
            <div>
              <h6 v-if="itemIndex == 0">{{ "Ratecard Name" }}</h6>
              <p>{{ item.rc_name }}</p>
            </div>
          </div>
          <div class="col-md-3">
            <div>
              <h6 v-if="itemIndex == 0">{{ "Ratecard Total Amount" }}</h6>
              <p>{{ item.rc_total_amount }}</p>
            </div>
          </div>
          <div class="col-md-3">
            <div>
              <h6 v-if="itemIndex == 0">{{ "Seat Type" }}</h6>
              <p>{{ item.sst_seat_type }}</p>
            </div>
          </div>
          <div class="col-md-3">
            <div>
              <h6 v-if="itemIndex == 0">{{ "Display Status" }}</h6>
              <p>{{ item.s_status_display }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center mt-5">
      <button class="btn-outline-blue">
        <router-link to="ticket-price-configurations">Cancel</router-link>
      </button>
    </div>
  </div>
</template>

<script>
import CinemasService from "@/services/CinemasService";
import MovieService from "@/services/MovieService";
import ScreenService from "@/services/ScreenService";
import MasterService from "@/services/MasterService";
import moment from "moment";
import { resolve } from "url";

export default {
  data() {
    return {
      // Saif
      viewTicketPriceConfigurationDetails: [],
      // Saif
    };
  },
  beforeMount() {
    const { md_id, ss_id } = this.$route.query;
    if (md_id && ss_id) {
      console.log("id :", md_id, ss_id);
      this.getTicketPriceConfiguration({ md_id, ss_id });
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    // saif

    getTicketPriceConfiguration: function ({ md_id, ss_id }) {
      CinemasService.GetTicketPriceConfigurationById({ md_id, ss_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            console.log("data :", data);
            this.viewTicketPriceConfigurationDetails = data.Records;
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          console.log("Catch Error Message :", error);
        });
    },

    // Saif
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/CinemaContainer/TicketPriceConfigurationComponents/viewTicketPriceConfiguration.vue